import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICriminalNominalstore } from "..";
import { IConsultaCriminal } from "../../../interface/criminal";

export interface ICriminalNominalModuleStore {
  resultadoCriminalNominal: IConsultaCriminal[] | null;
  mensagemCriminal?: string;
  consultaCriminalNominal(
    url: string,
    nome: string | undefined,
    nomeMae: string | undefined,
    nomePai: string | undefined,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaCriminalNominal(): void;
}

export default (set: SetState<ICriminalNominalstore>) =>
  ({
    resultadoCriminalNominal: null,
    async consultaCriminalNominal(url, nome, nomeMae, nomePai, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        const response = await axios.get(
          `${url}/wsCriminal/BuscarCidadaoNominal`,
          {
            params: {
              v_sNome: nome,
              v_sNomeMae: nomeMae,
              v_sNomePai: nomePai,
            },
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            criminal: {
              ...state.criminal,
              resultadoCriminalNominal: response.data,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          // toast.error(`${response.data}`, {
          //   position: toast.POSITION.TOP_CENTER,
          //   autoClose: 4000,
          // })
          set((state) => ({
            criminal: {
              ...state.criminal,
              resultadoCriminalNominal: null,
              mensagemCriminal: response.data,
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          return;
        }
        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          return;
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCriminalNominal() {
      set((state) => ({
        ...state,
        criminal: {
          ...state.criminal,
          resultadoCriminalNominal: null,
          mensagemCriminal: undefined,
        },
      }));
    },
  } as ICriminalNominalModuleStore);
